export enum NotificationStatus {
    New = 'New',
    Completed = 'Completed',
}
